import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center"
  },
  header: {
    backgroundColor: '#2C2C2E',
    height: 90,
    paddingHorizontal: 25,
    flexDirection: 'row',
    alignItems: "center",
    justifyContent: 'space-between',
    borderBottomColor: '#32BFB1',
    borderBottomWidth: 2,
  },
  checkbox: {
    marginHorizontal: 25
  },
  title: {
    color: "#fff",

    fontSize: 16,
  },
  actionContainer: {
    flex: 1,
    position: "relative",
    marginTop: "auto",
    alignItems: "center",
  },
  button: {
    padding: 10,
    width: 280,
    height: 60,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 50,
  },
  buttonText: {
    textTransform: "uppercase",
    fontWeight: "700",
    letterSpacing: 1,
    color: "#FFF",
  },
  icon: {
    width: 20,
  },
  form: {
    flex: 1,
    marginTop: 20,
  },
  input: {
    width: "90%",
    borderBottomColor: "#2C2C2E",
    borderBottomWidth: 0.5,
  },
  label: {
    fontSize: 14,
  },
  error: {
    fontSize: 12,
    color: "red",
    fontStyle: "italic",
    marginTop: 10,
  },
  containerSocialContract: {
    paddingRight: 25,
    marginTop: 20
  },
  description: {
    textAlign: 'justify',
    fontSize: 14,
    fontWeight: '400',
    lineHeight: 15
  },
  btnAdd: {
    height: 40,
    width: '100%',
    borderColor: '#32BFB1',
    borderWidth: 2,
    borderRadius: 20,
    marginTop: 20
  },
  iconAdd: {
    textAlign: 'center',
    marginTop: 5
  },
});

export default styles;
